import Vue from 'vue'
import Router from 'vue-router'

// import Login from '../components/login/login.vue'
// import Home from '../components/home.vue'
// import Welcome from '../components/welcome.vue'
const Login = () => import(/* webpackChunkName: "group-login" */ '../components/login/login.vue')
const Home = () => import(/* webpackChunkName: "group-login" */ '../components/home.vue')
const Welcome = () => import(/* webpackChunkName: "group-login" */ '../components/welcome.vue')

// import Courses from '../components/courses/courses.vue'
// import userCourses from '../components/userCourses/userCourses.vue'
// import Lessons from '../components/lessons/lessons.vue'
// import CoursePage from '../components/coursePage/coursePage.vue'
// import CoursePage from '../components/coursePage/coursePage2.vue'
const Courses = () => import(/* webpackChunkName: "group-course" */ '../components/courses/courses.vue')
const userCourses = () => import(/* webpackChunkName: "group-course" */ '../components/userCourses/userCourses.vue')
const Lessons = () => import(/* webpackChunkName: "group-course" */ '../components/lessons/lessons.vue')
const CoursePage = () => import(/* webpackChunkName: "group-course" */ '../components/coursePage/coursePage2.vue')

// import UserCenter from '../components/userCenter/userCenter.vue'
const UserCenter = () => import(/* webpackChunkName: "group-UserCenter" */ '../components/userCenter/userCenter.vue')

// import Ideas from '../components/ideas/ideas.vue'
const Ideas = () => import(/* webpackChunkName: "group-Ideas" */ '../components/ideas/ideas.vue')
const Activity = () => import('../components/activity/activity.vue')
const UpdateNameSuccess = () => import('../components/activity/updateNameSuccess.vue')
const UpdateNameFail = () => import('../components/activity/updateNameFail.vue')
// for管理中心
const AdminBoard = () => import('../components/adminBoard/adminBoard.vue')
const AccountSuccess = () => import('../components/adminBoard/accountSuccess.vue')
const AccountFail = () => import('../components/adminBoard/accountFail.vue')
const StuCenter = () => import('../components/stuCenter/stuCenter.vue')
const FAQ = () => import('../components/faq/faq.vue')

Vue.use(Router)

const router = new Router({
  routes: [
    // { path: '', redirect: '/login' },
    { path: '/login', component: Login },
    { path: '', redirect: '/faq' },
    
    // FAQ
    { name: 'FAQ', path: '/faq', component: FAQ },
    // { path: '/page', component: CoursePage },
    {
      path: '/home',
      component: Home,
      redirect: '/welcome',
      // meta: { keepAlive: true },
      // children: [
      //   { name: 'welcome', path: '/welcome', component: Welcome },
      //   { name: 'userCourses', path: '/userCourses', component: userCourses, meta: { keepAlive: true } },
      //   { name: 'userCenter', path: '/userCenter', component: UserCenter, meta: { keepAlive: true } },
      //   { name: 'lessons', path: '/lessons', component: Lessons, meta: { keepAlive: true } },
      //   { name: 'page', path: '/page', component: CoursePage, meta: { keepAlive: true } },
      //   { name: 'courses', path: '/courses', component: Courses, meta: { keepAlive: true } },
      //   { name: 'ideas', path: '/ideas', component: Ideas, meta: { keepAlive: true } },
      //   { name: 'activity', path: '/activity', component: Activity, meta: { keepAlive: true } },
      //   { name: 'updateNameSuccess', path: '/updateNameSuccess', component: UpdateNameSuccess, meta: { keepAlive: true } },
      //   { name: 'updateNameFail', path: '/updateNameFail', component: UpdateNameFail, meta: { keepAlive: true } },
      //   // for管理中心
      //   { name: 'adminBoard', path: '/adminBoard', component: AdminBoard, meta: { keepAlive: true } },
      //   { name: 'accountSuccess', path: '/accountSuccess', component: AccountSuccess, meta: { keepAlive: true } },
      //   { name: 'accountFail', path: '/accountFail', component: AccountFail, meta: { keepAlive: true } },
      //   { name: 'stuCenter', path: '/stucenter', component: StuCenter, meta: { keepAlive: true } }
      // ]
    }
  ],
  // mode: 'history',
  // scrollBehavior (to, from, savedPosition) {
  //   console.log('from: ', from)
  //   console.log('to: ', to)
  //   console.log('savedPosition: ', savedPosition)
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     if (from.meta.keepAlive) {
  //       from.meta.savedPosition = document.documentElement.scrollTop || document.body.scrollTop
  //     }
  //     return { x: 0, y: to.meta.savedPosition || 0 }
  //   }
  // }
})

// // fix error:Uncaught (in promise) Error: Avoided redundant navigation to current location
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }

// // 加入路径导航守卫
// router.beforeEach((to, from, next) => {
//   // to 将要访问的路径
//   // from 从何处跳转而来
//   // next 下一步的动作
//   if (to.path === '/login') return next()
//   const token = window.sessionStorage.getItem('token')
//   // console.log('导航守卫', token)
//   if (!token) return next('/login')
//   next()
// })
export default router
